import { createBrowserHistory } from "history";
import { useOAuthCallbackRelay } from "hooks/useOAuthCallbackRelay";
import Redirect from "pages/Redirect";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import {
    unstable_HistoryRouter as HistoryRouter,
    Route,
    Routes,
} from "react-router-dom";

import ConfirmationModalRoot from "components/organisms/ConfirmationModal/ConfirmationModalRoot";
import { NotificationSnackbar } from "components/organisms/NotificationSnackbar";
import ErrorRoute from "components/shared/ErrorRoute";
import { ProtectedRoute } from "components/shared/ProtectedRoute";

import "./App.css";
import Login from "./Login";
import Main from "./Main";

export const customHistory = createBrowserHistory();

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

function App() {
    useOAuthCallbackRelay();

    return (
        <>
            <NotificationSnackbar />
            <ConfirmationModalRoot />
            <GoogleReCaptchaProvider
                reCaptchaKey={RECAPTCHA_SITE_KEY}
                scriptProps={{
                    async: true,
                    defer: true,
                    appendTo: "head",
                }}
            >
                <HistoryRouter history={customHistory}>
                    <Routes>
                        <Route element={<Login />} path="/login" />

                        <Route element={<ProtectedRoute />}>
                            <Route path="/*" element={<Main />} />
                        </Route>
                        <Route element={<ErrorRoute />} path="/error" />
                        <Route element={<Redirect />} path="/redirect" />
                        <Route element={<Redirect />} path="/tiktok/redirect" />
                    </Routes>
                </HistoryRouter>
            </GoogleReCaptchaProvider>
        </>
    );
}

export default App;
